<template>
  <div class="wrapper " id="wrapper">
    <!-- Navbar -->
    <Navbar />
    <!-- Main Sidebar Container -->
    <Sidebar />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Header Title -->
      <Header />
      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">
          <div class="row ">
            <slot></slot>
            
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <Footer />
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
export default {
  components: {
    Header,
    Navbar,
    Footer,
    Sidebar
  }
};
</script>
